import { Component } from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

// Boundary di rendering: evita la "schermata nera" quando un componente figlio
// lancia un'eccezione, mostrando invece un alert con istruzioni per l'operatore.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary catturato:", error, info?.componentStack);
  }

  reset = () => this.setState({ hasError: false, error: null });

  render() {
    if (!this.state.hasError) return this.props.children;
    const title = this.props.title || "Si è verificato un problema";
    const hint = this.props.hint;
    return (
      <div className="flex min-h-[50vh] items-center justify-center p-6" data-testid="error-boundary-fallback">
        <div className="max-w-lg rounded-xl border border-amber-400/50 bg-amber-500/10 p-6 text-center">
          <AlertTriangle className="mx-auto mb-3 h-10 w-10 text-amber-500" />
          <h2 className="mb-2 text-lg font-black text-foreground">{title}</h2>
          {hint ? (
            <div className="mb-4 text-left text-sm text-muted-foreground">{hint}</div>
          ) : (
            <p className="mb-4 text-sm text-muted-foreground">Ricarica la pagina e riprova. Se il problema persiste, contatta il Back Office.</p>
          )}
          <div className="flex justify-center gap-2">
            <Button variant="outline" onClick={this.reset} data-testid="error-boundary-retry">Riprova</Button>
            <Button onClick={() => window.location.reload()} data-testid="error-boundary-reload">
              <RefreshCw className="mr-2 h-4 w-4" /> Ricarica pagina
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
